export const fontSizeOptions = [
  8,
  10,
  12,
  14,
  16,
  18,
  20,
  24,
  28,
  32,
  38,
  46,
  54,
  62,
  72,
];
export const fontFamilyOptions = [
  "Arial",
  "Arial Black",
  "Comic Sans MS",
  "Courier New",
  "Georgia",
  "Impact",
  "Lucida Console",
  "Lucida Sans Unicode",
  "Palatino Linotype",
  "Tahoma",
  "Times New Roman",
  "Trebuchet MS",
  "Verdana",
];

export const lineHeightOptions = [1.2, 1.4, 1.6, 1.8, 2, 2.2, 2.5, 3];
